import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type SubclipsPanelAppState = { highlightedSubclipIds?: string[] };

const initialState: SubclipsPanelAppState = {};

export const subclipsPanelSlice = createSlice({
  name: 'subclips',
  initialState,
  reducers: {
    setHighlightedSubclipIds: (state, action: PayloadAction<string[]>) => {
      state.highlightedSubclipIds = action.payload;
    },
  },
});

export const { setHighlightedSubclipIds } = subclipsPanelSlice.actions;

export const subclipsPanelReducer = subclipsPanelSlice.reducer;
